module.exports = __webpack_public_path__ + "static/media/april-img.1b6de91a.jpg";